
<div mat-dialog-title>
  <h2>{{"users." + (isUpdate ? 'Edit' : 'Create') + " user" | translate}}</h2>
  <button mat-icon-button class="close" [disabled]="loading" aria-label="Close" (click)="openConfirmDialog()">
    <mat-icon class="pop-close">close</mat-icon>
  </button>
</div>
<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<form [formGroup]="formGroup" *ngIf="!dataLoading">
  <mat-dialog-content>
    <div class="mat-dialog-body">
      <div class="fields-group">
        <div class="image-uploader">
          <div class="upload-container">
            <label [for]="'fileUploadInput'">
              <input type="file" accept=".png, .jpg, .jpeg" class="img-viewer" [id]="'fileUploadInput'"
                (change)="changeFileListener($event)">
              <div class="image-preview photo">
                <div class="remove-img" *ngIf="logoSrc" (click)="removeImg($event)">
                  <mat-icon>close</mat-icon>
                </div>
                <img [src]="logoSrc" *ngIf="logoSrc">
              </div>
            </label>
          </div>
          <div>
            <label>{{ 'forms.Profile Image' | translate }}</label>
            <p>
              {{ 'forms.JPG or PNG' | translate }}
              <span>({{ 'forms.MB max' | translate: {no: 2} }})</span>
            </p>
            <label [for]="'fileUploadInput'">
              <a>{{'forms.Upload/Select File' | translate }}</a>
            </label>
          </div>
        </div>
        <!-- <p class="has-error" *ngIf="!logoSrc && isSubmitted && !(fileTypeError || fileSizeError)">{{ 'forms.Required' | translate }}</p> -->
        <!-- <p class="has-error" *ngIf="fileTypeError">{{ 'forms.InvalidFile' | translate }}</p> -->
        <p class="mat-mdc-form-field-error" *ngIf="fileSizeError || fileTypeError">{{ 'messages.profileImageConstraint' | translate }}
          {{maxFileSize}} {{
          'forms.MB' | translate }}.</p>
      </div>
      <div class="fields-group mt-3">
        <mat-form-field class="mb-0">
          <mat-label>{{"entities.fullName"|translate}}</mat-label>
          <input matInput formControlName="Name" maxlength="150">
          <mat-error *ngIf="hasError('Name', 'required')">{{ 'messages.fullNameRequired' | translate }}</mat-error>
          <mat-error *ngIf="hasError('Name', 'pattern')">{{ 'forms.fullNameLettersAndSpacesOnly' | translate }}</mat-error>
          <mat-error *ngIf="hasError('Name', 'minlength')">{{ 'forms.minLengthIsCharacters' | translate: {num: 3}
            }}</mat-error>
        </mat-form-field>
      </div>
      <div class="fields-group mt-3">
        <app-select-has-search controlName="Role" [formGroupBuilder]="formGroup" [recordsData]="roles"
          [dataLoading]="rolesLoading" [required]="true" [errorMessage]="'messages.userRoleRequired'| translate"
          [titleField]="'users.user role'| translate" [searchTitle]="'forms.Search' | translate" [hasImage]="false"
          [key]="'name'" [valueKey]="true"></app-select-has-search>

        <!-- <mat-form-field class="mb-2" [class.loading]="rolesLoading">
          <mat-label>{{"users.user role" | translate}}</mat-label>
          <mat-select formControlName="Role" required>
            <mat-option *ngFor="let role of roles" [value]="role.id">{{role.name}}</mat-option>
          </mat-select>
          <mat-error *ngIf="hasError('Role', 'required')">{{ 'messages.userRoleRequired' | translate }}</mat-error>
        </mat-form-field> -->
      </div>
      <div class="fields-group mt-3">
        <div class="form-group">
          <mat-form-field class="phoneNumberleft">
            <mat-label>{{"entities.mobileNumber" | translate}}</mat-label>
            <input matInput formControlName="PhoneNumber" appOnlynumber maxlength="12" minlength="9">
            <span matSuffix>+966 </span>
            <mat-error *ngIf="hasError('PhoneNumber', 'required')">{{ 'messages.mobileNumberRequiredAndValid' |
              translate }}</mat-error>
            <mat-error *ngIf="hasError('PhoneNumber', 'notUniqe')">
              {{ 'forms.mobileNumberAlreadyUsed' | translate }}
            </mat-error>
            <mat-error *ngIf="hasError('PhoneNumber', 'pattern')">
              {{ 'forms.invalidPhoneNumber' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div class="fields-group mt-3">
        <mat-form-field class="mb-0">
          <mat-label>{{"forms.emailAddress"|translate}}</mat-label>
          <input matInput formControlName="Email" maxlength="100" type="email">
          <mat-error *ngIf="hasError('Email', 'required')">{{ 'messages.emailRequiredAndValid' | translate
            }}</mat-error>
          <mat-error *ngIf="hasError('Email', 'invalid')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
          <mat-error *ngIf="hasError('Email', 'pattern')">{{ 'forms.Invalid-Email' | translate }}</mat-error>
          <mat-error *ngIf="hasError('Email', 'notUniqe')">{{ 'auth.emailAlreadyExists' | translate }}</mat-error>
          <mat-error
            *ngIf="hasError('Email', 'minlength') && !hasError('Email', 'invalid') && !hasError('Email', 'pattern')">
            {{ 'forms.minLengthIsCharacters' | translate: {num: 5} }}
          </mat-error>
        </mat-form-field>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button type="button" [disabled]="loading" class="btn-grey" (click)="openConfirmDialog()">
      {{"forms.Cancel" | translate}}
    </button>
    <button (click)="saveRecord()" mat-raised-button color="primary" [disabled]="loading" [class.loading]="loading">
      {{(isUpdate ? 'general.Edit' : 'forms.Add') | translate}}
    </button>
  </mat-dialog-actions>
</form>
